import MentionModel from './bill_search_mention_model';
export default Backbone.Collection.extend({
  model: MentionModel
});